<template>
  <div>
    <ValidationObserver ref="createUserForm" slim>
      <form role="form" @submit.prevent="create_user_submit">
        <div class="row">

          <div class="col-6 form-group">
            <ValidationProvider rules="required|min:6|verify_password|password:@Confirmation" name="Password" v-slot="{ errors, classes }">
              <label class="form-label" for="password">Password</label>
              <input type="text" v-model="password" id="password" name="password" class="form-input" :class="classes" autocomplete="off"/>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div class="col-6 form-group">
            <ValidationProvider rules="required|password:@Password" name="Confirmation" v-slot="{ errors, classes }">
              <label class="form-label" for="confirmation">Confirmation</label>
              <input type="text" v-model="confirmation" id="confirmation" name="confirmation" class="form-input" :class="classes" autocomplete="off"/>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="col-6">
            <button @click.prevent="edit_contact" class="btn orcaBtn blueBtn">Edit Contact</button>
          </div>
          <div class="col-6">
            <button type="submit" class="btn orcaBtn">Create Contact Login</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {
      register_user: {
        first_name: 'Adam',
        surname: 'Thomas',
        email: 'it@geniusmoney.co.uk',
        password: '',
        password_confirmation: '',
        contact_id: '',
        disable: false

      }
    }
  }
}
</script>
